import { Injectable } from '@angular/core';
import { IconData, icons } from './icons';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  private icons: IconData[] = icons;
  readonly names: { [key: string]: IconData };
  constructor() {
    this.names = this.icons.reduce((acc: Record<string, IconData>, curr) => {
      acc[curr.name] = curr;
      return acc;
    }, {});
  }
  getIconData(iconName: string): IconData {
    return this.names[iconName];
  }
}
